/**
 * "Resume where I left off" persistence (2026-07-05).
 *
 * Tracks the most recently opened/worked Game Content word + the stage that
 * was on screen, in localStorage — the same persistence approach the app
 * already uses for durable client state (theme, session drafts). Survives
 * reloads and navigation; sessionStorage (used only for binder filters) would
 * not survive a browser restart.
 *
 * Written by GameWorkspace whenever a word/stage is on screen; read by the
 * Word Binder's "Last worked on" chip.
 */

const KEY = 'waw:last-worked';

export interface LastWorked {
  wordId: string;
  word: string;
  stage?: string;
  ts: string;
}

export function readLastWorked(): LastWorked | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as LastWorked;
    if (!parsed || typeof parsed.wordId !== 'string' || !parsed.wordId || typeof parsed.word !== 'string') {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeLastWorked(entry: LastWorked): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entry));
  } catch {
    // Storage full / private mode — the indicator is a nicety, never fatal.
  }
}
